import { createAction } from '@gef-ui/utils/fsaActions';
import { actionTypes } from '../constants';
/**
 * Handles merging of apm configuration options
 *
 * @documented
 * @category Action
 * @example
 *
 * dispatch(mergeApmConfig({ environment, serviceName }));
 *
 */ export const mergeApmConfig = createAction(actionTypes.MERGE_APM_CONFIG);
/**
 *  Handles clearing of apm configuration options whenever needed
 *
 * @documented
 * @category Action
 * @examples
 *
 * dispatch(clearApmConfig());
 *
 */ export const clearApmConfig = createAction(actionTypes.CLEAR_APM_CONFIG);
